"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(require("./app/core/level"));
__export(require("./app/core/logger"));
__export(require("./app/core/providers"));
//# sourceMappingURL=core.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/sung/WebstormProjects/exafe front/~/angular2-logger/core.js
// module id = ../../../../angular2-logger/core.js
// module chunks = 3